import React from "react";
import PropTypes from "prop-types";
import { styled, Typography, useTheme } from "@mui/material";
import { AppBar, Tabs, Tab, Box, Button } from "@mui/material";
import "./LoginRegister.scss";
import { Link, Navigate, useNavigate } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { myITPortal } from "../../Utilities/utility";



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = styled((theme) => ({
  loginTabs: {
    flexGrow: 1,
    backgroundColor: `rgba(255, 255, 255, 0.85)`,
    boxShadow: `0 8px 32px #CCCCCC`,
    borderRadius: "10px",
  },
}));

export default function LoginRegisterTabs() {
  const dispatch = useDispatch();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  function azureADLogin() {
    instance.loginRedirect(loginRequest).catch(e => {
      console.log(e);
    });
  }

  const handleClickRegister = () => {
    alert("Yet to be developed");
  };

  return (
    <div className="ssiat-lr-block">
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <span className="d-block">
            Click on the following link for Login
          </span>
          <div className="d-flex jc-center mt-1">
            <Link to="/">
              <Button
                className="pt-button--hero myid-login-btn-block"
                id="AzureAdLogin"
                onClick={azureADLogin}
              >
                <span> Login</span>
              </Button>
            </Link>
          </div>
          <div className="d-flex jc-center mt-1">
            <span>Having Issues?&nbsp;</span>
            <span>
            <a className="contact-us-text" href={myITPortal} target="_blank">
                Report Incident
              </a>
            </span>
          </div>
        </TabPanel>
      </SwipeableViews>
    </div>
  );
}
